import React,{ useEffect,useState } from 'react';
import DataReactTable from "./DataReactTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from "react-redux";
import ModelProduct from '../../../../../../Models/Product';
import { faUserSlash } from '@fortawesome/fontawesome-free-solid';
import {showNotification} from "../../../../../../shared/components/Notification";


const SpecsTables = ({ dispatch, data, features, specifications ,theme,rtl}) => {

    const [isTableLoaded,setLoaded] = useState(false);
    const vm = new ModelProduct();

    useEffect(()=>{
        setLoaded(false);
        if(typeof specifications !== 'undefined' || specifications!==null){
            setLoaded(true);
        }
    },[specifications]);

    const columns =[
        // {
        //     width: 300,
        //     Header: "Options",
        //     Cell: ({ cell }) => {
        //          // debugger
        //         return (
        //             <a href={"/s/"+cell.row.original.qr_id} className={ "btn btn-danger btn-sm m-0 mr-2 pt-1 pb-1 pl-2 pr-2"} onClick={e => {e.preventDefault(); removeMemberAccess(cell.row.original)}}>
        //                 Remove <FontAwesomeIcon icon={faUserSlash}/>
        //             </a>
        //         )
        //     }
        // },
        {
            Header: 'Name',
            accessor: 'ps_name'
        },{
            Header: 'Value',
            accessor: 'ps_value',
            width: 150
        }
    ];

    const tableStructure= {
        tableHeaderData: columns
    };

    return (


            <div>
                {isTableLoaded &&
                    <DataReactTable reactTableData={ tableStructure } />
                }
            </div>

    );
};

export default connect(state => ({
    data:state.product.productData,
    features:state.product.features,
    specifications:state.product.specifications,
    rtl: state.rtl,
    theme: state.theme
}))(SpecsTables);
